module.exports = __webpack_public_path__ + "img/italic.94d6376b.svg";